import domReady from '@wordpress/dom-ready';

domReady(() => {
  document.querySelectorAll('.video-modal').forEach((modal) => {
    modal.addEventListener('hide.bs.modal', () => {
      if (modal.contains(modal.ownerDocument.activeElement)) {
        modal.ownerDocument.activeElement.blur();
      }

      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
          'https://www.youtube-nocookie.com'
        );
      }
    });
  });
});
